import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '@merchant-portal/app/core/auth.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent } from 'ui-component/src/public-api';
import { DialogComponentService } from '../dialog.component.service';

@Component({
  selector: 'app-enable-authenticator-dialog',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './enable-authenticator-dialog.component.html',
  styleUrls: ['./enable-authenticator-dialog.component.scss'],
})
export class EnableAuthenticatorDialogComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private authService: AuthService,
    private dialogService: DialogComponentService
  ) {}

  laterEnableAuthenticator() {
    this.ref.close({ action: 'later' });
  }

  setupAuthenticator() {
    // Close the current dialog first
    this.ref.close({ action: 'setup' });

    // Open the authenticator setup dialog
    const setupDialogRef = this.dialogService.openAuthenticatorSetupDialog();

    // Handle the setup dialog result
    setupDialogRef.onClose.subscribe((result: any) => {
      if (result?.action === 'verified') {
        // Authenticator setup completed successfully
      } else if (result?.action === 'cancel') {
        // Authenticator setup was cancelled
      }
    });
  }
}
